import Vue from 'vue' 
import VueRouter from 'vue-router'
import INDEX from '../views/tabbar/index.vue'
import LOGIN from '../views/login/login.vue'





//-------------------------------------------------------------

//用户端user
import HOME from '../views/tabbar/home.vue'
import CHOOSEPRO from '../views/user/choosePro.vue'
import SIGN from '../views/user/sign.vue'
import LEAVELIST from '../views/user/leavelist.vue'
import LEAVEFORM from '../views/user/leaveform.vue'
import ATTLIST from '../views/user/attList.vue'//出勤记录
import SCORELIST from '../views/user/scoreList.vue'//积分记录
//管控端 manager
import MLISTDETAIL from '../views/manage/listDetail.vue'
import MSETSIGN from '../views/manage/setSign.vue'
import MSIGN_LIST from '../views/manage/setSignList.vue'
import PROJECTSETTING from '../views/manage/projectSetting.vue'//项目管理
import LEAVE from '../views/manage/leave.vue'//请假
import ATTENDANCE from '../views/manage/attendance.vue'//出勤
import ADDPRO from '../views/manage/addpro.vue'//新建项目
import MEMBERLIST from '../views/manage/memberList.vue'//项目人员列表
import SETMEMBER from '../views/manage/setmember.vue'//设置项目人员
import ROLElIST from '../views/manage/roleList.vue' //获取账号列表
import ADDACCOUNT from '../views/manage/addAccount.vue' //新增账号
import USERDETAIL from '../views/manage/userDetail.vue' //用户信息
import MSCORELIST from '../views/manage/scoreList.vue' //積分明細
//管理端 officer
import OFFICEPRODETAIL from '../views/officer/proDetail.vue'//项目详情
import CHECKWORK from '../views/officer/checkWork.vue'//考勤确认
import OFFATT from '../views/officer/offAtt.vue'//出勤汇总
import OFFSCORE from '../views/officer/score.vue'//出勤汇总







Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: INDEX,
    meta: {
      title: "",
      content: ""
    },
    redirect: "/home",
    children: [
      {
        path: '/home',
        name: 'home',
        component: HOME,
        meta: {
          title: "",
          content: "",
          login:true,
        }
      },
    ]
  },
  {
    path: "/login",
    name: "login",
    component: LOGIN,
    meta: {
      title: "登录",
      content: "登录",
      login:false,
    },
  },
  {
	  path: "/mListDetail",
	  name: "mListDetail",
	  component: MLISTDETAIL,
	  meta: {
	    title: "项目详情",
	    content: "项目详情"
	  },
	},
	{
	  path: "/projectSetting",
	  name: "projectSetting",
	  component: PROJECTSETTING,
	  meta: {
	    title: "积分",
	    content: "积分"
	  },
	},
	{
	  path: "/msetSign",
	  name: "msetSign",
	  component: MSETSIGN,
	  meta: {
	    title: "发布签到",
	    content: "发布签到"
	  },
	},
	{
	  path: "/userdetail",
	  name: "userdetail",
	  component: USERDETAIL,
	  meta: {
	    title: "基本信息",
	    content: "基本信息"
	  },
	},
	{
	  path: "/scorelist",
	  name: "scorelist",
	  component: MSCORELIST,
	  meta: {
	    title: "积分明细",
	    content: "积分明细"
	  },
	},
	{
	  path: '/msetSignList',
	  name: 'msetSignList',
	  component: MSIGN_LIST,
	  meta: {
	    title: "签到表",
	    content: "签到表"
	  }
	},
	{
	  path: '/leave',
	  name: 'leave',
	  component: LEAVE,
	  meta: {
	    title: "请假",
	    content: "请假"
	  }
	},
	{
	  path: '/attendance',
	  name: 'attendance',
	  component: ATTENDANCE,
	  meta: {
	    title: "出勤",
	    content: "出勤"
	  }
	},

	{
	  path: '/addpro',
	  name: 'addpro',
	  component: ADDPRO,
	  meta: {
	    title: "新建项目",
	    content: "新建项目"
	  }
	},
	{
	  path: '/memberlist',
	  name: 'memberlist',
	  component: MEMBERLIST,
	  meta: {
	    title: "项目人员",
	    content: "项目人员"
	  }
	},
	{
	  path: '/setmember',
	  name: 'setmember',
	  component: SETMEMBER,
	  meta: {
	    title: "设置项目人员",
	    content: "设置项目人员"
	  }
	},
	{
	  path: '/rolelist',
	  name: 'rolelist',
	  component: ROLElIST,
	  meta: {
	    title: "账号列表",
	    content: "账号列表"
	  }
	},
	{
	  path: '/addAccount',
	  name: 'addAccount',
	  component: ADDACCOUNT,
	  meta: {
	    title: "账号列表",
	    content: "账号列表"
	  }
	},
	{
	  path: '/choosePro',
	  name: 'choosePro',
	  component: CHOOSEPRO,
	  meta: {
	    title: "选择项目",
	    content: "选择项目"
	  }
	},
	{
	  path: '/sign',
	  name: 'sign',
	  component: SIGN,
	  meta: {
	    title: "签到",
	    content: "签到"
	  }
	},
	{
	  path: '/userLeaveList',
	  name: 'userLeaveList',
	  component: LEAVELIST,
	  meta: {
	    title: "请假记录",
	    content: "请假记录"
	  }
	},
	{
	  path: '/leaveForm',
	  name: 'leaveForm',
	  component: LEAVEFORM,
	  meta: {
	    title: "请假",
	    content: "请假"
	  }
	},
	{
	  path: '/attlist',
	  name: 'attlist',
	  component: ATTLIST,
	  meta: {
	    title: "出勤",
	    content: "出勤"
	  }
	},
	{
	  path: '/userScoreList',
	  name: 'userScoreList',
	  component: SCORELIST,
	  meta: {
	    title: "积分明细",
	    content: "积分明细"
	  }
	},
	{
	  path: '/prodetail',
	  name: 'prodetail',
	  component: OFFICEPRODETAIL,
	  meta: {
	    title: "项目详情",
	    content: "项目详情"
	  }
	},
	{
	  path: '/checkWork',
	  name: 'checkWork',
	  component: CHECKWORK,
	  meta: {
	    title: "考勤确认",
	    content: "考勤确认"
	  }
	},
	{
	  path: '/offAtt',
	  name: 'offAtt',
	  component: OFFATT,
	  meta: {
	    title: "出勤",
	    content: "出勤"
	  }
	},
	{
	  path: '/offscore',
	  name: 'offscore',
	  component: OFFSCORE,
	  meta: {
	    title: "积分",
	    content: "积分"
	  }
	},
]

const router = new VueRouter({
  // mode: 'history',
  routes:routes,

  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  }
})


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  const TOKEN = localStorage.getItem("token");

  // const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : false;

  if (to.meta && to.meta.mustLogin && !TOKEN) {
    next({ path: '/login' })
  } else {
		next()
    // if (to.name === "mine" && TOKEN && user.is_teacher == 1) {
    //   next({ path: '/tmine' })
    // } else {
    //   next()
    // }
  }

})



export default router
